<div id="alert-export">
  <c-card *transloco="let t">
    <c-card-body *ngIf="alert" class="px-3">
      <!-- Header Section -->
      <c-row class="mb-4">
        <c-col md="12" lg="8" class="d-flex align-items-center">
          <h2 class="mb-0">{{ alert.title }}</h2>
        </c-col>
        <c-col md="12" lg="4" class="text-end" data-html2canvas-ignore>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button color="info" cButton class="my-2" (click)="getAlert()">
              <svg cIcon class="me-2" name="cil-reload"></svg>
              {{ t('Refresh') }}
            </button>
            <button color="light" cButton class="my-2" (click)="exportAlert()">
              {{ t('Export Alert as PDF') }}
            </button>
            <a *ngIf="alert.ehs_insight_row_uid && okService.isEhsInsight()"
               color="success"
               cButton
               class="my-2 text-white"
               [href]="okService.ehsInsightIncidentUrl(alert.ehs_insight_row_uid)"
               target="_blank"
               rel="noopener noreferrer">
              <img src="assets/images/ehs-insight-logo.png" alt="" class="me-2" style="height: 1.1em; width: auto; vertical-align: -0.15em;">
              {{ t('EHS Insight') }}
            </a>
            <button color="light" cButton class="my-2" routerLink="/reports/alerts">
              <svg cIcon class="me-2" name="cil-chevron-left"></svg>
              {{ t('Back to Alerts') }}
            </button>
          </div>
        </c-col>
      </c-row>

      <c-row>
        <!-- Left Column -->
        <c-col sm="12" md="12" lg="6" class="mb-3">
          <!-- Alert Status Warning -->
          <c-card *ngIf="!alert.resolved" class="mb-3 border-danger">
            <c-card-body class="alert alert-danger mb-0" role="alert">
              <i class="fa-solid fa-exclamation-triangle me-2"></i>
              {{ t('Please start working through the escalation procedure until the situation is resolved.') }}
            </c-card-body>
          </c-card>

          <!-- Alert Action Buttons -->
          <c-card *ngIf="!alert.alert_loop && !alert.resolved && !alert.accepted" class="mb-3">
            <c-card-body>
              <c-row class="align-items-center">
                <c-col md="12" lg="6" class="text-center text-lg-end mb-2 mb-lg-0">
                  <div>
                    <b>{{ t('Acknowledge this Alert') }}:</b><br/>
                    <small class="text-muted">{{ t('Please acknowledge this Alert') }}</small>
                  </div>
                </c-col>
                <c-col md="12" lg="6" class="text-center text-lg-start">
                  <button cButton class="btn btn-info btn-lg text-white" (click)="acknowledgeAlert(alert)">
                    <i class="fa-solid fa-check me-2"></i>
                    {{ t('Acknowledge this Alert') }}
                  </button>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>

          <c-card *ngIf="alert.alert_loop && !alert.accepted" class="mb-3" data-html2canvas-ignore>
            <c-card-body>
              <c-row class="align-items-center">
                <c-col md="12" lg="6" class="text-center text-lg-end mb-2 mb-lg-0">
                  <div>
                    <b>{{ t('Accept this Alert') }}:</b><br/>
                    <small class="text-muted">{{ t('Please accept this Alert to take responsibility and stop the alert loop.') }}</small>
                  </div>
                </c-col>
                <c-col md="12" lg="6" class="text-center text-lg-start">
                  <button cButton class="btn btn-info btn-lg text-white" (click)="acceptAlert(alert)">
                    <i class="fa-solid fa-check me-2"></i>
                    {{ t('Accept this Alert') }}
                  </button>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>

          <c-card *ngIf="((alert.alert_loop && alert.accepted) || !alert.alert_loop) && !alert.resolved" class="mb-3">
            <c-card-body>
              <c-row class="align-items-center">
                <c-col md="12" lg="6" class="text-center text-lg-end mb-2 mb-lg-0">
                  <div>
                    <b>{{ t('Resolve this Alert') }}:</b><br/>
                    <small class="text-muted">{{ t('Please Resolve this Alert if the worker is ok.') }}</small>
                  </div>
                </c-col>
                <c-col md="12" lg="6" class="text-center text-lg-start">
                  <button cButton class="btn btn-success btn-lg text-white" (click)="resolveAlert(alert)">
                    <i class="fa-solid fa-check me-2"></i>
                    {{ t('Resolve this Alert') }}
                  </button>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>

          <!-- Verification Form -->
          <c-card *ngIf="alert.resolved" class="mb-3">
            <c-card-header class="text-center">
              <h5 class="mb-3">{{ t('How would you categorize this alert?') }}</h5>
              <div class="d-flex flex-wrap gap-2 justify-content-center mb-2">
                <button type="button" class="btn btn-sm" [ngClass]="{
                  'btn-success': verifyGroup.value.type == 'Real Emergency',
                  'btn-outline-secondary': verifyGroup.value.type && verifyGroup.value.type != 'Real Emergency',
                  'btn-outline-success': !verifyGroup.value.type
                }" (click)="verifyAlertClicked('Real Emergency')">
                  {{ t('Real Emergency') }}
                </button>
                <button type="button" class="btn btn-sm" [ngClass]="{
                  'btn-warning': verifyGroup.value.type == 'False Alarm',
                  'btn-outline-secondary': verifyGroup.value.type && verifyGroup.value.type != 'False Alarm',
                  'btn-outline-warning': !verifyGroup.value.type
                }" (click)="verifyAlertClicked('False Alarm')">
                  {{ t('False Alarm') }}
                </button>
                <button type="button" class="btn btn-sm" [ngClass]="{
                  'btn-info': verifyGroup.value.type == 'Test Alert',
                  'btn-outline-secondary': verifyGroup.value.type && verifyGroup.value.type != 'Test Alert',
                  'btn-outline-info': !verifyGroup.value.type
                }" (click)="verifyAlertClicked('Test Alert')">
                  {{ t('Test Alert') }}
                </button>
              </div>
              <div *ngIf="verifyGroup.value.type != '' && verifyGroup.value.information" class="mt-2">
                <i class="text-muted">{{ verifyGroup.value.information }}</i>
                <button type="button" class="btn btn-sm btn-link ms-2" (click)="editVerifyInfo()">
                  <i class="fas fa-edit text-info"></i>
                </button>
              </div>
            </c-card-header>
            <c-card-body *ngIf="verifyGroup.value.type != '' && edit_verify_info">
              <form [formGroup]="verifyGroup" cForm>
                <div class="mb-3">
                  <textarea
                    class="form-control"
                    [formControlName]="'information'"
                    cFormControl
                    rows="3"
                    placeholder="{{ t('Please provide a short summary of the alert') }}"
                  ></textarea>
                </div>
                <div class="text-center">
                  <button type="button" class="btn btn-info me-2" (click)="verifyAlert()">
                    <i class="fa-solid fa-check me-2"></i>
                    {{ t('Update Alert Information') }}
                  </button>
                  <button type="button" class="btn btn-light" (click)="cancelEditVerifyInfo()">
                    <i class="fas fa-times me-2"></i>
                    {{ t('Cancel') }}
                  </button>
                </div>
              </form>
            </c-card-body>
          </c-card>

          <!-- Worker Information Card -->
          <c-card class="mb-3">
            <c-card-header>
              <h5>{{ t('Worker Information') }}</h5>
            </c-card-header>
            <c-card-body *ngIf="alert.worker">
              <table class="table table-striped table-borderless mb-0">
                <tbody>
                  <tr>
                    <th class="text-warning text-end" style="width: 40%;">{{ t('Worker Name') }}:</th>
                    <td><strong>{{ alert.worker.name }}</strong></td>
                  </tr>
                  <tr>
                    <th class="text-warning text-end">{{ t('Company') }}:</th>
                    <td>{{ alert.company.company_name }}</td>
                  </tr>
                  <tr *ngIf="alert.ehs_insight_row_uid && okService.isEhsInsight()">
                    <th class="text-warning text-end">{{ t('EHS Insight Incident') }}:</th>
                    <td>
                      <a [href]="okService.ehsInsightIncidentUrl(alert.ehs_insight_row_uid)"
                         target="_blank" rel="noopener noreferrer">
                        {{ t('Open in EHS Insight') }}
                      </a>
                    </td>
                  </tr>
                  <tr *ngIf="alert.worker.phone">
                    <th class="text-warning text-end">{{ t('Phone') }}:</th>
                    <td>
                      <a href="tel:{{ alert.worker.phone }}">{{ alert.worker.phone }}</a>
                    </td>
                  </tr>
                  <tr *ngIf="alert.worker.cell">
                    <th class="text-warning text-end">{{ t('Alt Phone') }}:</th>
                    <td>
                      <a href="tel:{{ alert.worker.cell }}">{{ alert.worker.cell }}</a>
                    </td>
                  </tr>
                  <tr *ngIf="alert.worker.email">
                    <th class="text-warning text-end">{{ t('Email') }}:</th>
                    <td>
                      <a href="mailto:{{ alert.worker.email }}">{{ alert.worker.email }}</a>
                    </td>
                  </tr>
                  <tr *ngIf="alert.worker.information">
                    <th class="text-warning text-end align-top">{{ t('Information') }}:</th>
                    <td [innerHTML]="alert.worker.information | nl2br"></td>
                  </tr>
                  <tr *ngIf="alert.activity">
                    <th class="text-warning text-end align-top">{{ t('Timed Activity') }}:</th>
                    <td>
                      <strong class="fs-5">{{ alert.activity.name }}</strong><br/>
                      <small class="text-muted">
                        <i class="fa-solid fa-play text-success me-1"></i>{{ alert.activity.start_at_local }}
                        <i class="fa-solid fa-flag-checkered text-danger ms-3 me-1"></i>{{ alert.activity.end_at_local }}
                      </small><br/>
                      <span *ngIf="alert.activity.completed" class="badge text-bg-success mt-1">
                        {{ t('Activity Completed') }}
                      </span>
                    </td>
                  </tr>
                  <tr *ngIf="okService.hasFeature('app_connectivity') && alert.status && alert.status.working && alert.connectivity">
                    <th class="text-warning text-end align-top">{{ t('Connectivity') }}:</th>
                    <td>
                      <div class="d-flex flex-wrap gap-2 align-items-center">
                        <c-badge *ngIf="alert.connectivity.status" [color]="alert.connectivity.status.class">
                          {{ alert.connectivity.status.identifier }}
                        </c-badge>
                        <c-badge *ngIf="alert.connectivity.device == 'Android' && alert.connectivity.signal?.strength" [color]="alert.connectivity.signal.color">
                          <i class="fa-solid fa-signal me-1"></i>
                          {{ alert.connectivity.signal.label }}
                        </c-badge>
                        <c-badge *ngIf="alert.connectivity.battery?.percentage !== undefined" [color]="alert.connectivity.battery.color">
                          <i class="fa-solid fa-battery-half me-1"></i>
                          {{ alert.connectivity.battery.label }}
                        </c-badge>
                        <c-badge class="bg-secondary">
                          {{ alert.connectivity.device }}
                        </c-badge>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </c-card-body>
          </c-card>

          <!-- Worker Location Card -->
          <c-card *ngIf="alert.status" class="mb-3">
            <c-card-header>
              <h5>{{ t('Worker Location') }}</h5>
            </c-card-header>
            <c-card-body>
              <p *ngIf="alert.status.loc_time_local" class="mb-2">
                {{ t('Last Known Location was') }}
                <strong>{{ alert.status.loc_lat }}, {{ alert.status.loc_lng }}</strong>
                {{ t('at') }}
                <strong>{{ alert.status.loc_time_local }}</strong>
              </p>
              <img src="{{ alert.status.map }}" class="img-fluid rounded mb-2" alt="Worker location map">
              <p *ngIf="alert.status.loc_time_local" class="mb-0" data-html2canvas-ignore>
                <a href="https://www.google.com/maps/search/?api=1&query={{ alert.status.loc_lat }},{{ alert.status.loc_lng }}" target="_new" class="btn btn-sm btn-outline-primary">
                  <i class="fa-solid fa-map-location-dot me-1"></i>
                  {{ t('View location in your browser') }}
                </a>
              </p>
            </c-card-body>
          </c-card>

          <!-- What3Words Location Card -->
          <c-card *ngIf="okService.settings.w3w" class="mb-3">
            <c-card-header>
              <h5>
                <img src="/assets/images/what3words-icon-small.png" alt="what3words" class="me-2" style="height: 20px;">
                {{ t('what3words location') }}
              </h5>
            </c-card-header>
            <c-card-body>
              <div *ngIf="!alert.w3w" data-html2canvas-ignore>
                <button type="button" class="btn btn-primary" (click)="whatWords(alert)">
                  <i class="fa-solid fa-map me-2"></i>
                  {{ t('Get location') }}
                </button>
              </div>
              <div *ngIf="alert.w3w">
                <a href="{{ alert.w3w.map }}" target="_w3w" class="btn btn-link p-0">
                  <strong>{{ alert.w3w.words }}</strong>
                </a>
              </div>
            </c-card-body>
          </c-card>

          <!-- Vehicle Location Card -->
          <c-card *ngIf="alert.vehicle" class="mb-3">
            <c-card-header>
              <h5>{{ t('Vehicle Location') }}</h5>
            </c-card-header>
            <c-card-body>
              <p *ngIf="alert.vehicle.loc_time_local" class="mb-2">
                {{ t('Last Known Vehicle Location was') }}
                <strong>{{ alert.vehicle.loc_lat }}, {{ alert.vehicle.loc_lng }}</strong>
                {{ t('at') }}
                <strong>{{ alert.vehicle.loc_time_local }}</strong>
              </p>
              <img src="{{ alert.vehicle.map }}" class="img-fluid rounded mb-2" alt="Vehicle location map">
              <p *ngIf="alert.vehicle.loc_time_local" class="mb-0">
                <a href="https://www.google.com/maps/search/?api=1&query={{ alert.vehicle.loc_lat }},{{ alert.vehicle.loc_lng }}" target="_new" class="btn btn-sm btn-outline-primary">
                  <i class="fa-solid fa-map-location-dot me-1"></i>
                  {{ t('View location in your browser') }}
                </a>
              </p>
            </c-card-body>
          </c-card>

          <!-- Recent Messages Card -->
          <c-card *ngIf="alert.messages && alert.messages.length > 0" class="mb-3">
            <c-card-header>
              <h5>
                <i class="fa-regular fa-comment me-2"></i>
                {{ t('Recent Messages') }}
              </h5>
            </c-card-header>
            <c-card-body>
              <div *ngFor="let message of alert.messages; let last = last" [class.mb-3]="!last">
                <div>
                  <span *ngIf="message.type=='message'">
                    <i class="fa-regular fa-comment me-2"></i>
                    {{ message.information }}
                  </span>
                  <span *ngIf="message.type=='voice_message'">
                    <i class="fa-solid fa-voicemail me-2"></i>
                    {{ t('Voice Message') }}:
                    <a href="{{ message.information }}" target="_new" class="btn btn-sm btn-outline-primary ms-2">
                      <i class="fa-solid fa-play me-1"></i>
                      {{ t('Listen Now') }}
                    </a>
                  </span>
                </div>
                <small class="text-muted">
                  <i class="fa-regular fa-clock me-1"></i>
                  {{ message.time }}
                </small>
                <hr *ngIf="!last" class="mt-3 mb-0">
              </div>
            </c-card-body>
          </c-card>
        </c-col>

        <!-- Right Column -->
        <c-col sm="12" md="12" lg="6" class="mb-3">
          <!-- Alert Actions Card -->
          <c-card class="mb-3">
            <c-card-header>
              <h5>
                <i class="fa-solid fa-list-check me-2"></i>
                {{ t('Alert Actions') }}
              </h5>
            </c-card-header>
            <c-card-body>
              <div *ngFor="let action of alert.actions" [innerHTML]="action.html"></div>
            </c-card-body>
          </c-card>

          <!-- Alert Notes Card -->
          <c-card class="mb-3">
            <c-card-header (click)="view_notes=!view_notes" style="cursor: pointer;">
              <h5 class="mb-0">
                <i class="fa-solid fa-note-sticky me-2"></i>
                {{ t('Alert Notes') }}
                <i class="fa-solid fa-angles-down float-end"></i>
              </h5>
            </c-card-header>
            <ul class="list-group list-group-flush" [hidden]="!view_notes">
              <li class="list-group-item" *ngFor="let note of alert.notes">
                <div class="fs-6">{{ note.notes }}</div>
                <small class="text-muted" *ngIf="note.name">
                  <i class="fa-regular fa-user me-1"></i>
                  {{ note.name }} - {{ note.local_time }}
                </small>
              </li>
              <li class="list-group-item" *ngIf="!alert.notes || alert.notes.length === 0">
                <em class="text-muted">{{ t('No notes yet') }}</em>
              </li>
            </ul>
            <c-card-body>
              <button cButton class="btn btn-light w-100" data-bs-toggle="collapse" data-bs-target="#collapseUpdate" aria-expanded="false" aria-controls="collapseUpdate" data-html2canvas-ignore>
                <i class="fa-solid fa-note-sticky me-2"></i>
                {{ t('Enter your notes') }}
              </button>
              <div class="collapse mt-3" id="collapseUpdate">
                <form [formGroup]="formGroup" cForm (ngSubmit)="addNotes()">
                  <div class="mb-3">
                    <textarea
                      class="form-control"
                      [formControlName]="'notes'"
                      cFormControl
                      rows="4"
                      placeholder="{{ t('Enter your notes') }}"
                    ></textarea>
                  </div>
                  <button cButton class="btn btn-info text-white w-100" type="submit">
                    <i class="fa-solid fa-check me-2"></i>
                    {{ t('Update Notes') }}
                  </button>
                </form>
              </div>
            </c-card-body>
          </c-card>

          <!-- SMC Actions Card -->
          <c-card *ngIf="alert.arc_actions && alert.arc_actions.length > 0" class="mb-3">
            <c-card-header>
              <h5>
                <i class="fa-solid fa-tasks me-2"></i>
                {{ t('SMC Actions') }}
              </h5>
            </c-card-header>
            <c-card-body>
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let arcAction of alert.arc_actions">
                  <div class="fs-6">{{ arcAction.action }}</div>
                  <small class="text-muted" *ngIf="arcAction.time">
                    <i class="fa-regular fa-clock me-1"></i>
                    {{ arcAction.time | utcToTimezone:(okService.me?.timezone || okService.settings.timezone) }}
                  </small>
                </li>
              </ul>
            </c-card-body>
          </c-card>
          
          @if(okService.hasFeature('escalation_procedure')){

          <!-- Escalation Procedure Card -->
          <c-card *ngIf="alert.escalation_procedure" class="mb-3">
            <c-card-header>
              <h5>
                <i class="fa-solid fa-list-ol me-2"></i>
                {{ t('Escalation Procedure') }}
              </h5>
            </c-card-header>
            <c-card-body [innerHTML]="alert.escalation_procedure | nl2br"></c-card-body>
          </c-card>
          }

        </c-col>
      </c-row>
    </c-card-body>
  </c-card>
</div>
